import { ContentResponse, ContentType, File, PublicContentResponse } from "@authory-packages/core";
import { V3CNWrapper } from "./V3ContentNavbar.styles";
import { ItemMetadata } from "../ItemMetadata";
import { V3IconDownload } from "../Icons";
import { UnstyledLink } from "../ReusableStyledComponents";
import { V3Tooltip } from "../Tooltip";

interface V3ContentNavbarProps {
    content: ContentResponse | PublicContentResponse;
    isBusinessParent?: boolean;
    isPrivateView: boolean;
    viewOriginal?: boolean;
    byline?: { name: string; href: string };
}

export const V3ContentNavbar = ({ content, isBusinessParent = false, isPrivateView, viewOriginal = false, byline }: V3ContentNavbarProps) => (
    <V3CNWrapper $isPrivateView={isPrivateView}>
        <div>
            <ItemMetadata item={content} showRedirect={false} isB2B={isBusinessParent} viewOriginal={viewOriginal} allowUserThemable byline={byline} />
        </div>
        <div>
            {content.type === ContentType.PdfFile && !isPrivateView && (
                <V3Tooltip
                    tooltipContent={"Download"}
                    referenceContent={
                        <UnstyledLink href={content.type === ContentType.PdfFile ? (content.contentDetail as File).fileUrl : undefined}>
                            <V3IconDownload size="22" stroke="#ABB0BA" />
                        </UnstyledLink>
                    }
                />
            )}
        </div>
    </V3CNWrapper>
);
